<template>
  <div class="Guide" :class="{ show }" v-show="show">
    <div class="mainBox">
      <div class="box1">
        <!-- 左边按钮 -->
        <div class="mainll mainrr">
          <div
            class="row"
            v-for="item in leftList"
            :key="item.id"
            :class="{ rowAc: item.id === showId }"
          >
            <img
              :src="require(`@/assets/img/LeftTop/inco${item.type}.png`)"
              alt=""
            />
            <p>{{ item.name }}</p>
            <!-- 提示框 -->
            <div class="tit">
              <h3>
                <span>{{ item.name }}</span>
                <div class="ind">{{ showId }}/8</div>
              </h3>
              <div class="txt">{{ item.tit }}</div>
              <div class="btn">
                <div :class="{ noAc: showId === 1 }" @click="showId--">
                  <i class="el-icon-arrow-left"></i>上一条
                </div>
                <div @click="show = false">跳过</div>
                <div :class="{ noAc: showId === 8 }" @click="showId++">
                  下一条<i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右边按钮 -->
        <div class="mainrr" v-show="showId === 7">
          <!-- 提示框 -->
          <div class="tit">
            <h3>
              <span>更多</span>
              <div class="ind">{{ showId }}/8</div>
            </h3>
            <div class="txt">可回到首页，关闭/开启声音，点赞和分享等</div>
            <div class="btn">
              <div :class="{ noAc: showId === 1 }" @click="showId--">
                <i class="el-icon-arrow-left"></i>上一条
              </div>
              <div @click="show = false">跳过</div>
              <div :class="{ noAc: showId === 8 }" @click="showId++">
                下一条<i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          <div class="row" v-for="item in rightList" :key="item.id">
            <img
              :src="require(`@/assets/img/Goods/inco${item.type}.png`)"
              alt=""
            />
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 顶部楼层 -->
    <div class="titMap" v-show="showId===8">
      <!-- 提示框 -->
      <div class="tit">
        <h3>
          <span>地图</span>
          <div class="ind">{{ showId }}/8</div>
        </h3>
        <div class="txt">可切换楼层，或查看场景3D模型</div>
        <div class="btn">
          <div :class="{ noAc: showId === 1 }" @click="showId--">
            <i class="el-icon-arrow-left"></i>上一条
          </div>
          <div @click="show = false">关闭</div>
          <div :class="{ noAc: showId === 8 }" @click="showId++">
            下一条<i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Guide",
  components: {},
  data() {
    return {
      show: true,
      showId: 1,
      leftList: [
        { id: 1, name: "自动漫游", tit: "自动游览线上场馆", type: 1 },
        { id: 2, name: "场景导览", tit: "查看场景内所有镜头点位", type: 2 },
        { id: 3, name: "全景漫游", tit: "手动自主漫游", type: 3 },
        { id: 4, name: "迷你模型", tit: "查看场景3D模型", type: 4 },
        { id: 5, name: "顶部俯视", tit: "查看场景平面图", type: 5 },
        { id: 6, name: "热点列表", tit: "查看场景内所有交互热点", type: 6 },
      ],
      rightList: [
        { id: 7, name: "首页", type: 1 },
        { id: 8, name: "声音", type: 2 },
        { id: 9, name: "点赞", type: 3 },
        { id: 10, name: "分享", type: 4 },
        { id: 11, name: "全屏", type: 5 },
      ],
    };
  },
  computed: {},
  watch: {
    show(val){
      if(!val) sessionStorage.setItem('YHT_SWKK_FLAG',1)
    }
  },
  methods: {},
  created() {
    let flag= sessionStorage.getItem('YHT_SWKK_FLAG')
    if(flag) this.show=false
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.Guide {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
  position: absolute;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  .mainBox {
    position: absolute;
    bottom: 30px;
    right: 0px;
    width: 100%;
    .box1 {
      padding: 0 25px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      .mainrr {
        display: flex;
        position: relative;
        .tit {
          text-align: left;
          z-index: 10;
          position: absolute;
          top: -180px;
          left: 0;
          width: 300px;
          height: 180px;
          background-image: url("../assets/img/Union.png");
          background-size: 100% 100%;
          color: #fff;
          padding: 15px;
          h3 {
            font-size: 20px;
            color: #d8b275;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .ind {
              color: #fff;
              font-size: 12px;
            }
          }
          .txt {
            font-size: 14px;
            margin: 12px 0;
          }
          .btn {
            margin-top: 24px;
            display: flex;
            justify-content: space-around;
            & > div {
              cursor: pointer;
              font-size: 14px;
              padding: 6px 10px;
              border: 1px solid #d8b275;
              border-radius: 3px;
              i {
                padding-top: 2px;
              }
            }
            .noAc {
              border: 1px solid #ccc;
              color: #ccc;
              pointer-events: none;
            }
          }
        }

        .row {
          position: relative;
          width: 50px;
          text-align: center;
          margin-left: 18px;
          color: #fff;

          & > img {
            width: 50px;
          }

          p {
            font-size: 12px;
          }
        }
      }

      .mainll {
        .row {
          opacity: 0;
          pointer-events: none;
          width: 80px;
          margin-left: 0;
        }
        .rowAc {
          opacity: 1;
          pointer-events: auto;
        }
      }
    }
  }
  .titMap {
    z-index: 10;
    position: absolute;
    right: 20px;
    top: 28px;
    width: 184px;
    height: 219px;
    background-image: url("../assets/img/titMap.jpg");
    background-size: 100% 100%;
    border-radius: 6px;
    .tit {
      text-align: left;
      z-index: 10;
      position: absolute;
      bottom: -180px;
      left: -200px;
      width: 300px;
      height: 180px;
      background-image: url("../assets/img/Union2.png");
      background-size: 100% 100%;
      color: #fff;
      padding: 30px 15px 0;
      h3 {
        font-size: 20px;
        color: #d8b275;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .ind {
          color: #fff;
          font-size: 12px;
        }
      }
      .txt {
        font-size: 14px;
        margin: 12px 0;
      }
      .btn {
        margin-top: 24px;
        display: flex;
        justify-content: space-around;
        & > div {
          cursor: pointer;
          font-size: 14px;
          padding: 6px 10px;
          border: 1px solid #d8b275;
          border-radius: 3px;
          i {
            padding-top: 2px;
          }
        }
        .noAc {
          border: 1px solid #ccc;
          color: #ccc;
          pointer-events: none;
        }
      }
    }
  }
}
.show {
  opacity: 1;
  pointer-events: auto;
}
</style>